module.exports = "pegasus/assets/four-column-images-preview.png";